import React from 'react';
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

const Payments = () => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.Payments[key][currentLang];

  return (
    <section className="grid">
      <div className="contentfront">
        <div className="page-content payments-page">
          <h1>💳 {t("title")}</h1>
          <p>{t("intro")}</p>

          <div className="highlight-box">
            <h2>{t("acceptedTitle")}</h2>
            <ul className="styled-bullets">
              <li>{t("paypal")}</li>
              <li>{t("interac")}</li>
              <li>{t("cashTrade")}</li>
            </ul>

            <h2>{t("recommendationsTitle")}</h2>
            <ul className="styled-bullets">
              <li>{t("avoidFNF")}</li>
              <li>{t("verifyUser")}</li>
              <li>{t("getProof")}</li>
            </ul>

            <h2>{t("disclaimerTitle")}</h2>
            <p>{t("disclaimerText")}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Payments;
